<lib-modal-layout [title]="'Change Password'" [subtitle]="''">
  <form [formGroup]="form">
    <div>
      <lib-form-text
        label="Current Password"
        formControlName="oldPassword"
        [type]="'password'"
      >
      </lib-form-text>
    </div>
    <div>
      <lib-form-text
        label="Password"
        formControlName="newPassword"
        [type]="'password'"
      >
      </lib-form-text>
    </div>
    <div>
      <lib-form-text
        label="Confirm Password"
        formControlName="confirmPassword"
        [type]="'password'"
      >
      </lib-form-text>
    </div>
  </form>
  <div class="text-center">
    <lib-button
      [cssType]="'btn-primary'"
      text="Change Password"
      [type]="'button'"
      (click)="onSubmit()"
      [disabled]="!form.valid"
    >
    </lib-button>
  </div>
</lib-modal-layout>